'use client';
import { FC, useState, useRef } from 'react';

import Container from '@shared/Container';
import { getServiceId } from '@utils/searchbar/getServiceId';
import FlightSearchBar from '@domain/flight/searchBar';
import HotelSearchBar from '@domain/hotel/searchBar';
import TourSearchBar from '@domain/tour/searchBar';
import CarSearchBar from '@domain/carRental/searchBar';
import { HOMEPAGE_TAB_MENU_LIST } from '@constants/constants';

import TabMenu from './tabMenu';
import {
  Wrapper,
  TabWrapper,
  TabItemWrapper,
  TabMenuWrapper,
  TabItemSubWrapper,
} from './styled';

export type ServiceType = 'flight' | 'hotel' | 'tour' | 'cruise' | 'carRental';

type PropsType = {
  activeService?: ServiceType;
  title?: string;
};

const SearchBar: FC<PropsType> = ({ activeService = 'flight' }) => {
  const ref = useRef<HTMLDivElement>(null);

  const [tabValue, setTabValue] = useState<number>(getServiceId(activeService));

  const tabChange = (id: number) => {
    setTabValue(id);
  };

  return (
    <Wrapper>
      <Container noPadding className='searchbar__innerWrapper'>
        <TabWrapper>
          <TabMenuWrapper ref={ref}>
            <TabMenu
              tabs={HOMEPAGE_TAB_MENU_LIST}
              onTabChange={tabChange}
              defaultTabId={tabValue}
            />
          </TabMenuWrapper>
        </TabWrapper>
        <TabItemWrapper>
          <TabItemSubWrapper>
            {tabValue === 1 && <FlightSearchBar />}
            {tabValue === 2 && <HotelSearchBar />}
            {tabValue === 3 && <TourSearchBar />}
            {tabValue === 5 && <CarSearchBar />}
            {/* {tabValue === 4 && <CruiseSearchBar />} */}
          </TabItemSubWrapper>
        </TabItemWrapper>
      </Container>
    </Wrapper>
  );
};

export default SearchBar;
